<template>
  <div class="new-aboutus">
    <div class="top" v-show="showTop">
      <img src="../assets/images/new-aboutus/icon.png" />
    </div>
    <div class="content" v-show="showContent">
      <div class="c-item fade-in" :style="{animationDelay: '0.2s'}">
        <div>
          <img class="pic" src="../assets/images/new-aboutus/icon-1.png">
          <div class="tool">
            <img class="gps" src="../assets/images/new-aboutus/gps.png" />
            <span class="desc">江苏省南京市江宁区运粮河东路南京市政务数据中心</span>
          </div>
        </div>
      </div>
      <div style="width:.4rem"></div>
      <div class="c-item fade-in" :style="{animationDelay: '0.4s'}">
        <div>
          <img class="pic" src="../assets/images/new-aboutus/icon-2.png">
          <div class="tool">
            <img class="gps" src="../assets/images/new-aboutus/gps.png" />
            <span class="desc">江苏省南京市江宁区运粮河东路701号I栋-4楼</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showTop: false,
      showContent: false
    }
  },
  mounted() {
    // 控制动画顺序
    setTimeout(() => {
      this.showTop = true;
      setTimeout(() => {
        this.showContent = true;
      }, 100);
    }, 50);
  }
}
</script>

<style lang="scss" scoped>
.new-aboutus{
  background-color: #f5f5f5;
  
  // 动画定义
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .fade-in {
    animation: fadeInUp 0.5s ease forwards;
    opacity: 0;
  }
  
  .top{
    margin: 0 auto;
    width: 12rem;
    height:1.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      height:.5rem;
      width: 3.12rem;
      animation: fadeInUp 0.6s ease forwards;
      opacity: 0;
    }
  }
  
  .content{
    margin: 0 auto;
    margin-top: 0.8rem;
    width: 12rem;
    display: flex;
    padding-bottom: 1.2rem;
    .c-item{
      flex:1;
      .pic{
        width: 100%;
      }

      .tool{
        margin-top: 0.12rem;
        display: flex;
        align-items: center;
        .gps{
          display: block;
          width: .14rem;
          height: .17rem;
        }

        .desc{
          font-weight: 500;
          font-size: .16rem;
          color: #333333;
          margin-left: .1rem;
        }
      }
    }
  }
}

@media screen and (min-width: 2000px) {
  .new-aboutus{
    .top{
      height:1.2rem;
    }
    .content{
      margin-top: 0.3rem;
      .c-item{
        .tool{
            .desc{
              font-size: .14rem;
            }
        }
      }
    }
  }
}

@media screen and (max-width: 1700px) {
  .new-aboutus{
      .content{
        margin: 0 auto;
        margin-top: 0.1rem;
        width: 12rem;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        padding-bottom: 0.4rem;
        .c-item{
          flex:1;
          display: flex;
          justify-content: center;
          .pic{
            width: 10rem;
          }
          .tool{
            margin-top: 0.12rem;
            margin-bottom:0.4rem;
            text-align: center;
            .gps{
              display: block;
              width: .16rem;
              height: .2rem;
            }
            .desc{
              font-weight: 500;
              font-size: .16rem;
              color: #333333;
              margin-left: .1rem;
            }
          }
        }
      }
  }
}
</style>

